<template>
  <div>
    <hero-bar>
      User
    </hero-bar>
    <section class="section is-main-section">
      <card-component icon="ballot" class="addJob">
        <form @submit.prevent="submit">
          <b-input v-model="editEmail" type="hidden" />
          <div v-if="errors.length" class="column is-one-third">
            <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
              </ul>
          </div>
          <br>
        <div class="columns is-mobile is-multiline">
          <div class="column is-one-third">
            <b-field label="Email" custom-class="labelCharge" horizontal>
              <b-input type="email" v-model="email" class="mr-3" :disabled=isDisabled required />
            </b-field>
          </div>
        </div>
        <div class="columns is-mobile is-multiline">
          <div class="column is-one-third">
            <b-field label="Name" custom-class="labelCharge" horizontal>
              <b-input v-model="name" class="mr-3" required />
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="Surname" custom-class="labelCharge" horizontal>
              <b-input v-model="surname" class="mr-3" required />
            </b-field>
          </div>
        </div>
        <div class="columns is-mobile is-multiline">
          <div class="column is-one-third">
            <b-field label="Description" custom-class="labelCharge" horizontal>
              <b-input v-model="description" class="mr-3" />
            </b-field>
            <b-field label="Agency" custom-class="labelCharge" horizontal>
              <b-input v-model="agency" class="mr-3" />
            </b-field>
            <b-field label="Rep Code" custom-class="labelCharge" horizontal>
              <b-input v-model="repcode" class="mr-3" />
            </b-field>
            <b-field label="Licence" custom-class="labelCharge" horizontal>
              <b-input v-model="licence" class="mr-3" />
            </b-field>
            <b-field label="Primary Role" custom-class="labelCharge" horizontal>
              <b-select placeholder="Select role" v-model="role" required>
                <option v-for="(role, index) in roles" :key="index" :value="role.name">
                  {{ role.name }}
                </option>
              </b-select>
            </b-field>
            <radio-picker :options="{true: 'Active',false: 'Inactive'}" v-model="active"></radio-picker>
          <br>
          <hr>
          <b-field horizontal>
            <b-field grouped>
              <div class="control">
                <b-button native-type="submit" type="is-primary">Save</b-button>
              </div>
            </b-field>
          </b-field>
          </div>
        </div>
        </form>
        <hr>
        <b>Additional Roles</b>
        <div style="width:250px">
          <b-table ref="aroles" :data="roless" :columns="columns" @check="selectRole" checkable :header-checkable=false></b-table>
          <hr>
          <b-field horizontal>
            <b-field grouped>
              <div class="control">
                <b-button type="is-primary" @click="newRole">New Role</b-button>
              </div>
              <div class="control">
                <b-button type="is-primary" @click="deleteRole">Delete Role</b-button>
              </div>
            </b-field>
          </b-field>
          </div>
          <hr>
      </card-component>
      <b-modal :active.sync="showAddModal" :width="600" scroll="keep" >
      <div class="card">
        <header class="modal-card-head">
          <p class="modal-card-title">Add Role</p>
            <button type="button" class="delete" @click="closeModal()"/>
        </header>
        <div class="card-content">
          <RoleForm @saved="saveModal()" @cancelled="closeModal()" :edit="false"></RoleForm>
        </div>
      </div>
    </b-modal>
    </section>
</div>
</template>

<script>
import RadioPicker from '@/components/RadioPicker'
import CardComponent from '@/components/CardComponent'
import axios from 'axios'
import RoleForm from '@/components/RoleForm'

import HeroBar from '@/components/HeroBar'
export default {
  name: 'Forms',
  components: { HeroBar, RadioPicker, CardComponent, RoleForm },
  data () {
    return {
      aroles: null,
      editEmail: '',
      email: null,
      surname: null,
      name: null,
      description: '',
      agency: '',
      roles: [{ name: 'driver' }, { name: 'office' }, { name: 'admin' }],
      roless: [],
      role: null,
      repcode: '',
      active: true,
      errors: [],
      isDisabled: false,
      users: [],
      licence: '',
      arole: null,
      perm: null,
      products: [{ name: 'Perm 1', id: 2 }, { name: 'Perm 2', id: 3 }],
      columns: [{ field: 'name', label: '', width: '40' }
      ],
      showAddModal: false,
      selectedRole: null
    }
  },
  computed: {
  },
  methods: {
    submit (e) {
      var errorFound = false

      this.errors = []

      if (!this.isDisabled) {
        var x = ''
        var current = false
        for (x in this.users) {
          if (this.email === this.users[x].email) {
            current = true
            break
          }
        }

        if (current) {
          this.errors.push('This user email already exists.')
          errorFound = true
        }
      }
      if (this.errors.length > 0) {
        return true
      }
      e.preventDefault()

      if (!errorFound) {
        if (this.saveUser()) {
          setTimeout(() => {
            this.isLoading = false
            this.$buefy.snackbar.open({
              message: 'User has been saved',
              queue: false
            })
          }, 500)
        }
      }
    },
    async saveUser () {
      if (this.editEmail !== '') {
        this.putUser()
        // this.putUserRole()
      } else {
        this.postUser()
        // this.postUserRole()
      }
    },
    selectRole (row, checkedList) {
      this.selectedRole = checkedList.name
    },
    async putUser () {
      try {
        await axios.put(this.$store.state.apiUrl + 'user/' + this.email, {
          email: this.email,
          surname: this.surname,
          name: this.name,
          description: this.description,
          agency: this.agency,
          repcode: this.repcode,
          active: this.active,
          role: this.role,
          licence: this.licence
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    async postUser () {
      try {
        await axios.post(this.$store.state.apiUrl + 'user?tenant=prostock&app=transport', {
          email: this.email,
          surname: this.surname,
          name: this.name,
          description: this.description,
          agency: this.agency,
          repcode: this.repcode,
          active: this.active,
          role: this.role,
          licence: this.licence
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
          .then((response) => {
            console.log(response)
          })
      } catch (error) {
        console.log(error)
      }
    },
    async postUserRole () {
      try {
        await axios.post(this.$store.state.apiUrl + 'user/role', {
          email: this.email,
          role: this.arole
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
          .then((response) => {
            console.log(response)
          })
      } catch (error) {
        console.log(error)
      }
    },
    async putUserRole () {
      try {
        await axios.post(this.$store.state.apiUrl + 'user/role/' + this.editEmail, {
          role: this.role
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
          .then((response) => {
            console.log(response)
          })
      } catch (error) {
        console.log(error)
      }
    },
    async deleteUserRole (role) {
      try {
        await axios.put(this.$store.state.apiUrl + 'user/role/delete', {
          email: this.email,
          role: this.selectedRole
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
          .then((response) => {
            console.log(response)
          })
      } catch (error) {
        console.log(error)
      }
    },
    async getUser (email) {
      try {
        const { data } = await axios.get(this.$store.state.apiUrl + 'user/' + email, {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
        this.editEmail = email
        this.email = email
        this.surname = data[0].surname
        this.name = data[0].name
        this.description = data[0].description
        this.agency = data[0].agency
        this.repcode = data[0].repcode
        this.active = data[0].active
        this.licence = data[0].licence
        this.role = data[0].role
      } catch (error) {
        console.log(error)
      }
    },
    async getUserPermissions (email) {
      try {
        const { data } = await axios.get(this.$store.state.apiUrl + 'user/role?email=' + email, {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
        var i = 0
        for (i = 0; i < data.length; i++) {
          this.roless.push({
            date: data[i].name
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getUserRoles (email) {
      try {
        const { data } = await axios.get(this.$store.state.apiUrl + 'user/role?email=' + email, {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
        var i = 0
        for (i = 0; i < data.length; i++) {
          this.roless.push({
            name: data[i].role
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getUsers () {
      try {
        const { data } = await axios.get(this.$store.state.apiUrl + 'user', {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
        this.users = data
      } catch (error) {
        console.log(error)
      }
    },
    openAddModal () {
      this.showAddModal = true
    },
    newRole () {
      this.$store.commit('setEmail', this.editEmail)
      this.openAddModal()
    },
    deleteRole () {
      this.deleteUserRole()
      this.roless = []
      this.getUserRoles(this.editEmail)
      window.location.reload(true)
    },
    closeModal () {
      this.showAddModal = false
      this.showEditModal = false
    },
    saveModal () {
      this.showAddModal = false
      this.showEditModal = false
      /* this.roless = []
      this.getUserRoles(this.editEmail)
      this.$refs.aroles.refresh() */
      window.location.reload(true)
    }
  },
  created () {
    this.getUsers()
    if (this.$route.params.email) {
      this.getUser(this.$route.params.email)
      // this.getUserPermissions(this.$route.params.email)
      this.getUserRoles(this.$route.params.email)
      this.isDisabled = true
    }
  }
}
</script>
